import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry auth failures or client errors — let the SPA redirect.
        if (error && typeof error === "object" && "status" in error) {
          const s = (error as { status: number }).status;
          if (s === 401 || (s >= 400 && s < 500)) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
